import React from "react";
import JobCardViewComponent from "./JobCardViewComponent";



class JobCardView extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      jobNumber: ""
    }
  }

  goToPage(page) {
    this.props.history.push(page)
  }

  render() {

    if (this.props.workspace) {
      return (<JobCardViewComponent goToPage={this.goToPage.bind(this)} jobNumber={this.props.jobNumberFromWorkspace} />)
    }

    else
      return (<JobCardViewComponent goToPage={this.goToPage.bind(this)} jobNumber={this.props.match.params.jobNumber} />)
  }

}

export default (JobCardView)